// !! Keep in sync with the backend com.lewara.backend.core.billing.FeatureSet enum !!
// A feature-set is a bundle of capabilities granted by a plan tier or purchased as an add-on.
export const FEATURE_SETS = {
  CORE: "CORE",
  PROJECT_MANAGEMENT: "PROJECT_MANAGEMENT",
  INVOICING: "INVOICING",
  REPORTING: "REPORTING",
  PERSONNEL_PLANNING: "PERSONNEL_PLANNING",
  TIME_TRACKING: "TIME_TRACKING",
  DOCUMENT_DESIGN: "DOCUMENT_DESIGN",
  DAY_SUBMISSIONS: "DAY_SUBMISSIONS",
}

// !! Keep in sync with the backend com.lewara.backend.core.billing.PlanTier enum !!
export const PLAN_TIERS = {
  BASIC: "BASIC",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
}
